module.exports = __webpack_public_path__ + "img/companyImg3.e0420f57.jpg";